const when = (s) => { try { return new Date(s).toLocaleString(undefined, { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch (e) { return ""; } };

export const CampaignHistory = ({ list }) => (
  <section className="mt-16" data-testid="campaign-history">
    <h2 className="font-display text-2xl font-extrabold tracking-tight">Sent emails</h2>
    <div className="mt-4 border border-black/15 bg-white">
      {!list.length ? <p className="p-8 text-center text-sm text-[#57534E]" data-testid="campaign-history-empty">Nothing sent yet.</p> : (
        <ul>
          {list.map((c) => {
            const failed = Array.isArray(c.failed) ? c.failed.length : 0;
            return (
              <li key={c.id} className="flex flex-wrap items-center gap-x-4 gap-y-1 border-b border-black/5 px-5 py-3" data-testid={`campaign-${c.id}`}>
                <span className="min-w-0 flex-1 break-words text-sm font-semibold">{c.subject}</span>
                <span className="text-xs text-[#57534E]">{when(c.created_at)}</span>
                <span className={`text-xs font-bold ${c.status === "done" ? "text-[#0A0A0A]" : "text-[#E62314]"}`} data-testid={`campaign-${c.id}-status`}>
                  {c.status === "done" ? `Sent to ${c.sent ?? 0} of ${c.total ?? 0}` : `Sending… ${c.sent ?? 0}/${c.total ?? 0}`}{failed ? ` · ${failed} failed` : ""}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  </section>
);
